module.exports = __webpack_public_path__ + "../static/img/base_cisco_xr.936d0dfd.png";